import React from 'react';
import { useNavigate } from 'react-router-dom';

const DashboardCard = ({ icon: Icon, label, badge, path, color }) => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        .dash-card {
          background: white;
          border-radius: 16px;
          padding: 20px 12px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 10px;
          cursor: pointer;
          position: relative;
          box-shadow: 0 2px 10px rgba(232,80,10,0.08);
          transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);
          min-height: 105px;
          user-select: none;
          -webkit-tap-highlight-color: transparent;
        }
        .dash-card:hover {
          box-shadow: 0 8px 28px rgba(232,80,10,0.20);
          transform: translateY(-4px) scale(1.02);
        }
        .dash-card:active {
          transform: translateY(-1px) scale(0.99);
        }
        .dash-icon-wrap {
          width: 52px;
          height: 52px;
          background: linear-gradient(135deg, #E8500A 0%, #FF6B2C 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 22px;
          box-shadow: 0 4px 12px rgba(232,80,10,0.30);
          flex-shrink: 0;
        }
        .dash-label {
          font-size: 12px;
          font-weight: 700;
          color: var(--text-dark);
          text-align: center;
          line-height: 1.3;
        }
        .dash-badge {
          position: absolute;
          top: 8px;
          right: 8px;
          background: var(--primary);
          color: white;
          font-size: 11px;
          font-weight: 800;
          min-width: 22px;
          height: 22px;
          border-radius: 11px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 5px;
          box-shadow: 0 2px 6px rgba(232,80,10,0.40);
          animation: badgePulse 2s infinite;
        }
        @keyframes badgePulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.1); }
        }
        @media (min-width: 768px) {
          .dash-card { min-height: 120px; padding: 24px 14px; gap: 12px; }
          .dash-icon-wrap { width: 58px; height: 58px; font-size: 24px; }
          .dash-label { font-size: 13px; }
        }
      `}</style>
      <div className="dash-card" onClick={() => navigate(path)}>
        <div className="dash-icon-wrap">
          <Icon />
        </div>
        <span className="dash-label">{label}</span>
        {badge > 0 && (
          <div className="dash-badge">{badge}</div>
        )}
      </div>
    </>
  );
};

export default DashboardCard;
